

  <!-- Button trigger modal -->
  <!-- <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
    Launch demo modal
  </button> -->

  <!-- Modal -->
  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          ...
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary">Save changes</button>
        </div>
      </div>
    </div>
  </div>


<!-- HOME SECTION -->
<div id="home">
	<div id="carouselExampleAutoplaying" class="carousel slide" data-bs-ride="carousel">
		<div class="carousel-inner">
		  <div class="carousel-item active">
			<img src="/assets/images/7107-bg-1.jpg" class="d-block w-100" alt="...">
			<div class="home-text wow fadeInUp" data-wow-delay="0.9s">
				<h1>7107<span>ISLANDS</span></h1>
				<h4>PLACEMENT AND PROMOTIONS INC,</h4>
				<p>The Overseas Manpower Placement Agency for All Seasons and All Nations</p>
			</div>
			<!-- <div class="carousel-caption d-none d-md-block wow fadeInRight" data-wow-delay=".6s">
				<h1>7107 Islands Placement and Promotions Inc. The Overseas Manpower Placement Agency for All Seasons and All Nations</h1>
			</div> -->
			<!-- <div class="carousel-item">
				<img src="/assets/images/ads/home-bg-2.jpg" class="d-block w-100" alt="...">
			</div>
			<div class="carousel-item">
				<img src="/assets/images/ads/home-bg-3.jpg" class="d-block w-100" alt="...">
			</div>
			<div class="carousel-item">
				<img src="/assets/images/ads/home-bg-4.jpg" class="d-block w-100" alt="...">
			</div> -->
		</div>
		
		
		<button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="prev">
		  <span class="carousel-control-prev-icon" aria-hidden="true"></span>
		  <span class="visually-hidden">Previous</span>
		</button>
		<button class="carousel-control-next" type="button" data-bs-target="#carouselExampleAutoplaying" data-bs-slide="next">
		  <span class="carousel-control-next-icon" aria-hidden="true"></span>
		  <span class="visually-hidden">Next</span>
		</button>
	  </div>
</div>
<!-- ABOUT SECTION -->
<!-- <section id="about" class="parallax-section">
	<div class="container">
		<div class="row align-items-center">
      <div class="team-img wow fadeInUp " data-wow-delay="0.9s">
				<img src="/assets/images/7107-team.jpg" class="img-fluid" alt="">
			</div>

      <div class="about-text offset-md-2 col-md-8 wow fadeInUp text-justify d-flex align-items-center justify-content-center flex-column" data-wow-delay="0.6s">
        
			  <h3 class="">Who we are ?</h3>
				<p>7107 Islands Placement and Promotions, Inc. is a placement agency with over 20 years-experience in the deployment of qualified and trained semi-skilled, skilled, engineers, medical professionals and overseas Filipino workers with specialized trainings and skills, to many Asian, Western and European, and Middle East countries. (For the list of countries where 7107 has supplied OFWs and its workers” deployment profile, please click link)</p>

        <a href="our-deployment"><button class="btn btn-info">Our Deployment</button></a>
			</div>

		</div>
	</div>
</section> -->

<section id="specialization">
  <div class="container-xxl">
    <div class="text-content col-md-10 offset-md-1 text-center wow fadeInUp" data-wow-delay=".6s">
      <h4 class="text-center" style="color: #00b33b; font-weight: bold;">FEATURED</h4>
      <h2>The industries covered include the following:</h2>
      <p>Acquired by its Chairman Joel P. Longares in 2003, 7107 Islands Placement and Promotions, Inc. has since then shifted its thrust to deploying skilled workers and professionals to big names in global business, and worker friendly host countries like Samsung, Hyundai and Hiap Seng Engineering companies among others, and to countries like Australia, Canada, Japan and Saudi Arabia among others. (For list of companies 7107 Islands has supplied workers, and for countries where it has deployed workers)</p>
    </div>
    <div class="row wow fadeInUp" data-wow-delay=".8s">
		<div class=" col-sm-6 col-md-6 col-lg-3">
			<div class="card">
				<a [routerLink]="['/engineering']"><img src="/assets/images/engineering.png" alt=""></a>
				<div class="intro">
				  <h5>Engineering & Construction</h5>
				  <p>Civil works, private enterprise, and other fields involving infrastructure maintenance and development
				</p>
			</div>
		</div>
		
      </div>
  
	  <div class=" col-sm-6 col-md-6 col-lg-3">
		<div class="card">
			<a [routerLink]="['/medical']"><img src="/assets/images/medical.jpg" alt=""></a>
			<div class="intro">
			  <h5>Medical</h5>
			  <p>Healthcare industry with companies that provide care, manufacture medication and medical equipment, as well as provides support to health-related services.</p>
			</div>
		  </div>
	  </div>
	  
	  <div class=" col-sm-6 col-md-6 col-lg-3">
		<div class="card">
			<a [routerLink]="['/hotel-and-restaurant']"><img src="/assets/images/hotel-and-restaurant.jpg" alt=""></a>
			<div class="intro">
			  <h5>Hotel & Restaurant</h5>
			  <p>Hospitality, Food, and beverage industries. A field of high demand for high performance professionals</p>
			</div>
		  </div>
	  </div>
	  
	  <div class=" col-sm-6 col-md-6 col-lg-3">
		<div class="card">
			<a [routerLink]="['/manufacturing']"><img src="/assets/images/manufacturing.jpg" alt=""></a>
			<div class="intro">
			  <h5>Manufacturing</h5>
			  <p>involved in manufacturing of goods for a country's economy.</p>
			</div>
		  </div>
	  </div>

    </div>
  </div>
</section>


<!-- CONTACT SECTION -->
<section id="contact" class="parallax-section">
	<div class="container-xxl">
		<div class="row">

			<div class="wow fadeInUp offset-md-1 col-md-5 col-sm-6" data-wow-delay="0.6s">
				<div class="contact_des text-justify">
					<h3>What We Do?</h3>
					<p>One of 7107 Islands Placement and Promotions, Inc.’s  primary objectives is to help Filipino workers land their dream jobs abroad, providing them with a chance to improve their lives and those of their families. They work with employers worldwide to source highly-skilled workers in various fields, including healthcare, hospitality, engineering, and construction.</p>
					<p>Employing a rigorous screening process to ensure that its candidates meet the employer's requirements. They conduct initial interviews to assess a candidate's qualifications and suitability, including language proficiency tests, practical skills assessments, and personality profiling. After this, candidates undergo further training to enhance their skills and improve their chances of securing employment abroad.</p>
				</div>
			</div>

			<div class="wow fadeInUp col-md-5 col-sm-6" data-wow-delay="0.9s">
				<div class="contact_detail">
					<div class="section-title">
						<h2>Inquire with us</h2>
					</div>
					<form action="#" method="post">
						<input name="name" type="text" class="form-control" id="name" placeholder="Name">
					  	<input name="email" type="email" class="form-control" id="email" placeholder="Email">
					  	<textarea name="message" rows="5" class="form-control" id="message" placeholder="Message"></textarea>
						<div class="col-md-6 col-sm-10">
							<input name="submit" type="submit" class="form-control" id="submit" value="SEND">
						</div>
					</form>
				</div>
			</div>

		</div>
	</div>
</section>

<!-- DETAIL SECTION -->
<!-- <section id="director" class="parallax-section">
	<div class="container">
		<div class="row">

			<div class="col-md-12 col-sm-12 wow bounceIn">
				<div class="section-title text-center">
					<h2 class="content-title">Company Directors</h2>
					<p>Our Great Leaders</p>
				</div>
			</div>

			<div id="owl-directory" class="row">

				<div class="col-md-4 offset-md-2 item-1 wow fadeInLeft col-sm-4" data-wow-delay="0.9s">
					<div class="director-wrapper">
						<img src="./assets/images/board-directors/jpl.jpg" class="img-fluid" alt="Directory" onContextMenu="return false;">
							<div class="directory-thumb text-center">
								<h3>Joel P. Longares</h3>
								<h6>Chief Executive Officer</h6>
							</div>
					</div>
				</div>

				<div class="col-lg-3 col-md-2 item-2 wow fadeInUp col-sm-3" data-wow-delay="0.6s">
					<div class="director-wrapper">
						<img src="./assets/images/board-directors/s.lambarte.jpg" class="img-fluid" alt="Directory" onContextMenu="return false;">
							<div class="directory-thumb text-center">
								<h3>Salvacion Lambarte</h3>
								<h6>Director</h6>
							</div>
					</div>
				</div>

				<div class="col-md-4 item-3 wow fadeInRight col-sm-4" data-wow-delay="0.9s">
					<div class="director-wrapper">
						<img src="./assets/images/board-directors/r.deleon.jpg" class="img-fluid" alt="Directory" onContextMenu="return false;">
							<div class="directory-thumb text-center">
								<h3>Renato De Leon</h3>
								<h6>General Manager</h6>
							</div>
					</div>
				</div>

				<div class="col-lg-3 col-md-2 item-4 wow fadeInUp col-sm-3" data-wow-delay="0.6s">
					<div class="director-wrapper">
						<img src="./assets/images/board-directors/n.tugado.jpg" class="img-fluid" alt="Directory" onContextMenu="return false;">
							<div class="directory-thumb text-center">
								<h3>Nike Tugado</h3>
								<h6>Operations Manager</h6>
							</div>
					</div>
				</div>
				
			</div>

		</div>
	</div>
</section> -->
<!-- Back top -->
<!-- <a href="#back-top" class="go-top"><i class="fa fa-angle-up"></i></a> -->

<link href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">
<script src="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/js/bootstrap.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>



<script>
    // Modal Auto load on refresh
    $(document).ready(function()
    {
      $('#exampleModal').modal('show');
    })  
</script>
